module.exports = __webpack_public_path__ + "static/img/vir.16b81e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/vir.svg
// module id = L+4k
// module chunks = 0